<template>
  <div>
    <a-card>
      <a-page-header
          :ghost="false"
          :title="dorm.name"
      >
        <template slot="tags">
          <a-tag color="blue">
            {{ dorm.code }}
          </a-tag>
        </template>
        <template slot="extra">
          <a :href="'https://' + dorm.host" target="_blank" style="margin-right: 8px">
            <a-icon type="link" /> {{ dorm.host }}
          </a>
          <a-dropdown placement="bottomRight">
            <a-menu slot="overlay" @click="handleRunScriptClick">
              <a-menu-item key="leases"> Przeładuj konfigurację DHCP </a-menu-item>
              <a-menu-item key="firewall"> Przeładuj zaporę sieciową </a-menu-item>
              <a-menu-item key="reload"> Przeładuj usługi </a-menu-item>
              <a-menu-item key="free-storage"> Zwolnij miejsce na dysku </a-menu-item>
            </a-menu>
            <a-button type="default"> Uruchom skrypt <a-icon type="down" /> </a-button>
          </a-dropdown>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="Brama">
            {{ dorm.gateway }}
          </a-descriptions-item>
          <a-descriptions-item label="Maska">
            {{ dorm.mask }}
          </a-descriptions-item>
          <a-descriptions-item label="Zakres od">
            {{ dorm.rangeStart }} - {{ dorm.rangeEnd }}
          </a-descriptions-item>
          <a-descriptions-item v-if="dorm.status" label="Użycie CPU">
            <a-tooltip :title="'Używane ' + JSON.parse(dorm.status).cpu_usage + '%'">
              <a-progress style="min-width: 200px" :percent="JSON.parse(dorm.status).cpu_usage" />
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item v-if="dorm.status" label="Użycie RAM">
            <a-tooltip :title="'Używane ' + JSON.parse(dorm.status).memory_used + ' z ' + JSON.parse(dorm.status).memory_total + ' (może zawierać SWAP)'">
              <a-progress style="min-width: 200px" :percent="JSON.parse(dorm.status).memory_usage_percentage" />
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item v-if="dorm.status" label="Użycie dysku">
            <a-tooltip :title="'Używane ' + JSON.parse(dorm.status).disk_usage + '%'">
              <a-progress style="min-width: 200px" :percent="JSON.parse(dorm.status).disk_usage" />
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item v-if="dorm.status" label="Uruchomienie systemu">
            {{ JSON.parse(dorm.status).uptime }}
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </a-card>

    <a-modal
        :visible="scriptExecution"
        title="Skrypt"
        :maskClosable="false"
        :closable="true"
        :keyboard="true"
        :width="'90%'"
        :footer="null"
        @ok="handleCloseScript"
        @cancel="handleCloseScript">
      <DormPipeline v-if="scriptExecution" :script="scriptName" :dorm="dorm.code" />
    </a-modal>
  </div>
</template>

<script>
import "./Dorm.vue";
import DormPipeline from "@/components/dorm/DormPipeline.vue";

export default {
  name: "Dorm",
  props: {
    dorm: {
      type: Object,
      required: true
    }
  },
  components: {
    DormPipeline
  },
  data() {
    return {
      scriptExecution: false,
      scriptName: null
    };
  },
  methods: {
    handleRunScriptClick(event) {
      console.log(this.dorm);
      this.scriptName = `${event.key}`
      this.scriptExecution = true;
    },
    handleCloseScript() {
      this.scriptName = null;
      this.scriptExecution = false;
    }
  }
};
</script>
